import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/semantic-platform/data-governance/suggestions/")({
  component: LegacySuggestionsRedirect,
});

/** 待确认建议已并入标签中心·建议审核（统一标签体系 D1） */
function LegacySuggestionsRedirect() {
  return <Navigate to="/semantic-platform/tag-center/suggestions" replace />;
}
